// extracted by mini-css-extract-plugin
export default {"Wrap":"ChatModeration_Wrap__lap3T"};